import { SortOrder } from 'antd/es/table/interface';
import { TTask } from 'data/types/pillarsActionPlan.types';

// Due Date sort for the Action Plan tasks, aligned with the Workshops / Events
// session date sort (GROW-4272): tasks without a date always sit at the
// bottom, in both directions; only dated tasks follow the requested order.
// antd negates the comparator result for 'descend', so the "empty last"
// result is pre-negated to survive that.
export const compareTaskDueDates = (
  a: TTask,
  b: TTask,
  sortOrder?: SortOrder,
): number => {
  const aDate = a.dueDate || null;
  const bDate = b.dueDate || null;
  if (!aDate && !bDate) {
    return 0;
  }
  const emptyLast = sortOrder === 'descend' ? -1 : 1;
  if (!aDate) {
    return emptyLast;
  }
  if (!bDate) {
    return -emptyLast;
  }
  return aDate.localeCompare(bDate);
};
